"use client"

import { css } from "@emotion/react"
import styled from "@emotion/styled"
import Image from "next/image"
import { DesktopOnly, LargeDesktop, Mobile } from "ui"
import { versionedAsset } from "utils"

const AnimationLayout = styled.div<{ template: "A" | "B" }>`
  padding: 16px 0;
  position: relative;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 0;
  }

  ${(props) => props.template === "A" && props.theme.breakpoints.up("md")} {
    padding: 0;
    height: 316px;
  }
  ${(props) => props.template === "A" && props.theme.breakpoints.up(1500)} {
    padding: 0;
    height: 300px;
  }
`

const ImageContainer = styled.div<{ template: "A" | "B" }>`
  width: 100%;
  position: relative;
  overflow: hidden;
  height: auto;
  aspect-ratio: 440/253;
  z-index: 0;
  ${(props) => props.theme.breakpoints.up("md")} {
    /* position: absolute; */
    aspect-ratio: 1440/476;
    height: auto;
  }

  ${(props) =>
    props.template === "A" &&
    css`
      height: 207px;
      z-index: 0;
      aspect-ratio: unset;
    `}
  ${(props) => props.template === "A" && props.theme.breakpoints.up("md")} {
    position: absolute;
    height: 316px;
    aspect-ratio: unset;
  }
  ${(props) => props.template === "A" && props.theme.breakpoints.up(1500)} {
    position: absolute;
    height: 300px;
    aspect-ratio: unset;
  }
`

const BusImage = styled(Image)<{ template: "A" | "B" }>`
  z-index: 1;
  bottom: 0;
  left: -40%;
  position: absolute;
  transform: translateX(-100%);
  /* Slower and smoother bus entrance */
  animation: slideBusIn 2.2s cubic-bezier(0.77, 0, 0.175, 1) forwards;
  animation-delay: 0.3s;
  ${(props) => props.template === "B" && props.theme.breakpoints.up("md")} {
    bottom: 7%;
    left: 1%;
    width: 58vw;
    height: auto;
  }
  ${(props) => props.template === "B" && props.theme.breakpoints.up(1500)} {
    bottom: 0%;
    left: 7%;
  }
  ${(props) =>
    props.template === "A" &&
    css`
      left: -25%;
    `}
  ${(props) => props.template === "A" && props.theme.breakpoints.up("md")} {
    bottom: 7%;
    left: 1%;
  }
  ${(props) => props.template === "A" && props.theme.breakpoints.up(1500)} {
    bottom: 0%;
    left: 1%;
  }

  @keyframes slideBusIn {
    from {
      transform: translateX(-100%);
    }
    to {
      transform: translateX(0);
    }
  }
`

export default function BusAnimation({
  locale,
  template,
}: {
  locale: string
  template: "A" | "B"
}) {
  const isInverted = locale === "en" || locale === "ru"
  return (
    <AnimationLayout template={template}>
      <ImageContainer template={template}>
        <Mobile>
          <BusImage
            src={versionedAsset(
              isInverted ? "/images/busEn.svg" : "/images/mini-bus.png",
            )}
            width={template === "B" ? 423 : 346}
            height={template === "B" ? 163 : 133}
            alt="hero"
            priority
            template={template}
          />
          <Image
            src={"/images/newlandingHeroSM.svg"}
            fill
            alt="hero"
            style={{
              objectFit: "cover",
              objectPosition: "bottom",
              transform: isInverted ? "scaleX(-1)" : "scaleX(1)",
            }}
            priority
          />
        </Mobile>
        <DesktopOnly>
          <BusImage
            src={versionedAsset(
              isInverted ? "/images/busEn.svg" : "/images/landingBus.svg",
            )}
            width={template === "B" ? 798 : 540}
            height={template === "B" ? 308 : 210}
            alt="hero"
            priority
            template={template}
          />
          <Image
            src={"/images/newlandingHeroMD.svg"}
            fill
            alt="hero1"
            style={{
              objectFit: "cover",
              objectPosition: "center",
              transform: isInverted ? "scaleX(-1)" : "scaleX(1)",
            }}
            priority
          />
        </DesktopOnly>
        <LargeDesktop>
          <BusImage
            src={versionedAsset(
              isInverted ? "/images/busEn.svg" : "/images/landingBus.svg",
            )}
            width={template === "B" ? 1064 : 700}
            height={template === "B" ? 410 : 260}
            alt="hero"
            priority
            template={template}
          />
          <Image
            src={"/images/newlandingHeroXL.svg"}
            fill
            alt="hero1"
            style={{
              objectFit: "cover",
              objectPosition: "center",
              transform: isInverted ? "scaleX(-1)" : "scaleX(1)",
            }}
            priority
          />
        </LargeDesktop>
      </ImageContainer>
    </AnimationLayout>
  )
}
